import {TextField, Field, type SectionProps} from '../controls';
import {PdfUploadField} from '../PdfUploadField';
import {MirrorLock} from '../mirrorLock';

export function SupportSection({config, patch, groupSlug, isNew}: SectionProps) {
  return (
    <div className='space-y-5'>
      <MirrorLock field='coveragePeriod'>
        <TextField
          label='Coverage period'
          hint='Shown on the landing page, e.g. "January 1, 2026 — December 31, 2026".'
          value={config.coveragePeriod}
          onChange={(coveragePeriod) => patch({coveragePeriod})}
        />
      </MirrorLock>
      <MirrorLock field='supportContacts'>
        <TextField
          label='Support phone'
          hint='Concierge phone — appears throughout and fills the {phone} token.'
          value={config.supportPhone}
          onChange={(supportPhone) => patch({supportPhone})}
        />
        <TextField
          label='Support text line'
          hint='Optional SMS number shown on the FAQ contact card.'
          value={config.supportText}
          onChange={(supportText) => patch({supportText: supportText || undefined})}
        />
        <TextField
          label='Support email'
          hint='Optional email shown on the FAQ card and the already-enrolled notice.'
          value={config.supportEmail}
          onChange={(supportEmail) => patch({supportEmail: supportEmail || undefined})}
        />
      </MirrorLock>
      <MirrorLock field='benefitsContact'>
        <TextField
          label='Benefits contact'
          hint='Who members are told to ask about benefits, throughout the site. Blank uses the default “HR department / HR office”; e.g. “local office”.'
          value={config.benefitsContact}
          onChange={(benefitsContact) => patch({benefitsContact: benefitsContact || undefined})}
        />
      </MirrorLock>
      <MirrorLock field='comparisonPdf'>
        <Field
          label='Comparison PDF'
          hint='Optional plan-comparison PDF linked from the header. Blank hides the link.'
        >
          <PdfUploadField
            groupSlug={groupSlug}
            isNew={isNew}
            value={config.comparisonPdfUrl}
            onChange={(comparisonPdfUrl) => patch({comparisonPdfUrl})}
          />
        </Field>
      </MirrorLock>
    </div>
  );
}
